////////LIBRARY/////////
import update from 'immutability-helper'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const kioskPricesManager = {
	[ActionsTypes.POST_KIOSK_PRICES_MANAGER]: (state) =>
		update(state, {
			kioskPricesManager: {
				isLoading: {
					$set: true,
				},
			},
			columns: {
				isSearchfieldUpdated: {
					$set: false,
				},
			},
		}),

	[ActionsTypes.POST_KIOSK_PRICES_MANAGER_SUCCESS]: (state, payload) => {
		const paging = {
			totalElements: payload.data.headerContent.contentPagined.totalElements,
			totalPages: payload.data.headerContent.contentPagined.totalPages,
		}

		return update(state, {
			kioskPricesManager: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: payload.data.headerContent.contentPagined.content,
				},
				paging: {
					$set: paging,
				},
				header: {
					$set: payload.data.headerParam.filters,
				},
			},
		})
	},
	[ActionsTypes.POST_KIOSK_PRICES_MANAGER_FAILURE]: (state, payload) =>
		update(state, {
			kioskPricesManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
}

export default kioskPricesManager
